import React, { Component } from "react"
import ReactDOM from "react-dom"
import createReactClass from 'create-react-class'
// Adds `${enter_class}` prop together with `${enter_class}-active` to each child
// if is_updating changes from true to false
// Inspired by React's ReactCSSTransitionGroup
export default createReactClass({
  getInitialState() {
    return {additional_classes: []};
  },

  getDefaultProps() {
    return {
      is_updating: false,
      enter_class: '',
      enter_timeout: 750
    };
  },

  componentDidUpdate(prevProps, prevState) {
    const was_updating = !this.props.is_updating && prevProps.is_updating;
    if (!was_updating) { return; }

    return this.setState({additional_classes: [this.props.enter_class]}, () => {
      // Force repaint of dom elements
      React.Children.forEach(this.props.children, child => {
        return ReactDOM.findDOMNode(this.refs[`item-${child.key}`]).scrollTop;
      });

      return this.setState({additional_classes: [this.props.enter_class, `${this.props.enter_class}-active`]}, () => {
        return setTimeout(() => {
          return this.setState({additional_classes: []});
        }
        , this.props.enter_timeout);
      });
    });
  },

  render() {
    const children = React.Children.map(this.props.children, child => {
      return React.cloneElement(child, { ref: `item-${child.key}` });
    });

    return <div className={this.state.additional_classes.join(' ')}>{children}</div>;
  }
});
